export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/refresh-3b2eb8ec3930c10b11b987adf06093d9.svg";